import type { HouseholdSharingStatus } from './household-sharing';

export const FROZEN_SAVE_MONETIZATION_PRODUCT_ID = 'frozensave' as const;
export const FROZEN_SAVE_MONETIZATION_APPLICATION_ID = 'frozen-save' as const;

export type FrozenSaveMonetizationProfile =
  | 'commercial-capable-disabled'
  | 'editorial-advertising-eligible-disabled';

export interface FrozenSaveMonetizationActivation {
  readonly billable: false;
  readonly checkoutAllowed: false;
  readonly realCharge: false;
  readonly automaticRenewal: false;
  readonly automaticTrialActivation: false;
  readonly automaticEntitlementGrant: false;
  readonly realStorePurchaseAllowed: false;
  readonly storeSubmissionAllowed: false;
  readonly realAdvertisingAllowed: false;
  readonly providerTagIntegrationAllowed: false;
  readonly providerCmpIntegrationAllowed: false;
  readonly canonicalAdServingAllowed: false;
  readonly paymentProfileCreationAllowed: false;
  readonly merchantAccountCreationAllowed: false;
  readonly spendAllowed: false;
}

export interface FrozenSaveNativeAccountReference {
  readonly applicationId: typeof FROZEN_SAVE_MONETIZATION_APPLICATION_ID;
  readonly opaqueProductSubject: string;
}

export interface FrozenSaveMonetizationProjection {
  readonly productId: typeof FROZEN_SAVE_MONETIZATION_PRODUCT_ID;
  readonly profiles: readonly FrozenSaveMonetizationProfile[];
  readonly accountAuthority: 'native-product-account';
  readonly ledgerSubject: 'opaque-product-subject-scoped-by-application-id';
  readonly dohmId: 'optional-federation-only';
  readonly myDohm: 'minimal-read-only-access-and-promotion-projection-only';
  readonly nativeAccount: FrozenSaveNativeAccountReference | null;
  readonly activation: FrozenSaveMonetizationActivation;
}

/**
 * Frontière locale vers les contrats de monétisation. Elle ne reçoit que le
 * statut du compte produit Frozen Save : ni DOHM ID ni My DOHM ne peuvent
 * devenir l'autorité du compte ou du sujet de ledger.
 */
export interface FrozenSaveMonetizationPort {
  readonly enabled: false;
  projection(status: HouseholdSharingStatus): FrozenSaveMonetizationProjection;
}
